export const BADI_GUARANTEE_POPUP_ACTION = 'badi_guarantee';
export const ANNOTATION_TYPE_WARNING = 'warning';
